import { render, staticRenderFns } from "./investmentClues9.vue?vue&type=template&id=187c9cce&scoped=true&"
import script from "./investmentClues9.vue?vue&type=script&lang=js&"
export * from "./investmentClues9.vue?vue&type=script&lang=js&"
import style0 from "./investmentClues9.vue?vue&type=style&index=0&id=187c9cce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187c9cce",
  null
  
)

export default component.exports